import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedRoles }) => {
  // Get user info from localStorage (from your login API)
  const userDataString = localStorage.getItem("user");

  // Check if user is authenticated
  if (!userDataString) {
    return <Navigate to="/login" replace />;
  }

  let userData;
  try {
    userData = JSON.parse(userDataString);
  } catch (error) {
    console.error("Error parsing user data:", error);
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }

  const userRole = userData.role; // This comes from your API: 'HR', 'MANAGER', 'EMPLOYEE'

  // Check if user has the required role
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Redirect based on their actual role
    switch (userRole) {
      case "HR":
        return <Navigate to="/hrms/dashboard" replace />;
      case "MANAGER":
        return <Navigate to="/hrms/manager-dashboard" replace />;
      case "EMPLOYEE":
        return <Navigate to="/hrms/employee-dashboard" replace />;
      default:
        localStorage.removeItem("user");
        return <Navigate to="/login" replace />;
    }
  }

  console.log("✅ ProtectedRoute: Access granted for role:", userRole);
  return children;
};

export default ProtectedRoute;
